(() => {
  const dialog = document.querySelector('#v2-cart-drawer');
  if (!dialog || !dialog.showModal) return;
  const section = 'dp-v2-cart-content';
  const root = window.Shopify?.routes?.root || '/';
  const content = dialog.querySelector('[data-cart-content]');
  const status = dialog.querySelector('[data-cart-status]');
  const errorBox = dialog.querySelector('[data-cart-error]');
  let busy = false, opener;
  function setBusy(value) {
    busy = value;
    content.inert = value;
    content.setAttribute('aria-busy', String(value));
    status.hidden = !value;
  }
  function render(sections) {
    const html = sections?.[section];
    if (!html) return false;
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('#v2-cart-content');
    if (!next) return false;
    content.replaceChildren(...next.childNodes);
    return true;
  }
  async function refresh() {
    const response = await fetch(`${root}?sections=${section}`, {headers:{Accept:'application/json'}, cache:'no-store'});
    if (!response.ok || !render(await response.json())) throw new Error('Your cart could not be loaded.');
  }
  function showError(text) {
    errorBox.querySelector('[data-cart-error-text]').textContent = text;
    errorBox.hidden = false;
  }
  async function open({sections, trigger, added = false} = {}) {
    if (busy) return true;
    opener = trigger || opener || document.activeElement;
    if (!dialog.open) {dialog.showModal();document.documentElement.classList.add('v2-cart-open');}
    errorBox.hidden = true;
    status.textContent = added ? 'Added to your cart…' : 'Loading your cart…';
    setBusy(true);
    try {
      if (!render(sections)) await refresh();
    } catch {
      content.replaceChildren();
      showError(added ? 'Your item was added, but the cart could not be displayed. Try again below; you do not need to add it again.' : 'We couldn’t load your cart. Check your connection and try again.');
    } finally {setBusy(false);}
    return true;
  }
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('v2-cart-open');
    opener?.focus({preventScroll:true});
  });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button,a[href],input,select,textarea,[tabindex="0"]')]
      .filter(el => !el.disabled && !el.closest('[inert]') && el.getClientRects().length);
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
  });
  dialog.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-close]')) {dialog.close();return;}
    if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) {dialog.close();return;}
    if (event.target.closest('[data-cart-retry]')) {open();return;}
    const button = event.target.closest('[data-cart-quantity]');
    if (!button || busy) return;
    const key = button.closest('[data-line-key]').dataset.lineKey;
    const control = button.dataset.cartControl;
    status.textContent = 'Updating your cart…';errorBox.hidden = true;setBusy(true);
    try {
      const response = await fetch(`${root}cart/change.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:Number(button.dataset.cartQuantity),sections:[section],sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'This quantity is not available.');
      if (!render(result.sections)) await refresh();
    } catch (error) {
      // Refresh after an uncertain update so retry cannot operate on a stale quantity.
      try {await refresh();} catch {content.replaceChildren();}
      showError(error.message || 'We couldn’t update your cart. Check your connection and try again.');
    } finally {
      setBusy(false);
      const next = content.querySelector(`[data-line-key="${CSS.escape(key)}"] [data-cart-control="${control}"]`);
      if (dialog.open) (next || dialog.querySelector('[data-cart-close]')).focus({preventScroll:true});
    }
  });
  document.querySelector('.v2-cart-link')?.addEventListener('click', event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();open({trigger:event.currentTarget});
  });
  window.dpV2Cart = {open, section};
})();
